/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringCapexDto } from '../../models/backend-monitoring-capex-dto';

export interface MonitoringScenariosCapexesList$Params {
  scenario_id: number;
}

export function monitoringScenariosCapexesList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosCapexesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringCapexDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosCapexesList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringCapexDto>>;
    }),
  );
}

monitoringScenariosCapexesList.PATH = '/api/monitoring/scenarios/{scenario_id}/capexes/';
